// src/components/logo/LogoIcon.tsx
import { useTheme } from '@mui/material/styles';

type Props = {
  size?: number;   // px
  color?: string;  // override fill color
};

export default function LogoIcon({ size = 28, color }: Props) {
  const theme = useTheme();
  const fill = color ?? theme.palette.primary.main;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      width={size}
      height={size}
      role="img"
      aria-label="Logo icon"
    >
      <path
        d="M 4.66 22.547001 L 6.952 23.870001 L 6.952 4.892 L 9.758 3.266001 L 9.758 25.49 L 12.048 26.812 L 12.048 1.948 L 14.854 0.329 L 14.854 31.671 L 8.928 28.25 C 7.441 27.392 5.954 26.534 4.467 25.674999 L 1.855 24.167 L 1.855 7.833 L 4.66 6.214001 L 4.66 22.547001 L 4.66 22.547001 Z M 22.242001 22.844 L 22.242001 9.156 L 25.048 10.777 L 25.048 21.225 L 22.242001 22.844 Z M 27.339001 22.547001 L 27.339001 9.452999 L 19.951 5.188 L 19.951 30.052 L 17.145 31.671 L 17.145 0.329 L 30.145 7.833 L 30.145 24.167 L 27.532 25.674 C 26.045 26.533001 24.559 27.392 23.072001 28.25 L 22.242001 28.729 L 22.242001 25.49 L 27.339001 22.546 L 27.339001 22.547001 Z"
        fill={fill}
        fillRule="evenodd"
      />
    </svg>
  );
}
